"use client";

import { useEffect } from "react";
import { RefreshCw } from "lucide-react";

import { Button } from "@/components/ui/button";
import { taskToast } from "@/lib/task-toast";
import { trackBoundaryError } from "@/lib/telemetry/bpm-telemetry";

export default function TaskListError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const errorMessage = error.message || "Ha ocurrido un error inesperado.";

  useEffect(() => {
    let nextEventId: string | null = null;
    try {
      nextEventId = trackBoundaryError(error, { digest: error.digest });
    } catch {
    }

    taskToast.error("No se pudo mostrar esta vista", {
      description: nextEventId ? `${errorMessage} Código de error: ${nextEventId}` : errorMessage,
      duration: 10000,
    });
  }, [error, error.digest, errorMessage]);

  return (
    <div className="flex h-full items-center justify-center p-6" role="alert">
      <div className="max-w-md text-center">
        <h2 className="text-lg font-semibold text-gray-900">
          No se pudo mostrar esta vista
        </h2>
        <p className="mt-2 text-sm text-gray-600">
          Reintenta la carga para volver a sincronizar esta pantalla.
        </p>
        <Button type="button" variant="outline" size="sm" onClick={reset} className="mt-4">
          <RefreshCw className="mr-2 h-3.5 w-3.5" />
          Reintentar
        </Button>
      </div>
    </div>
  );
}
